/* eslint-disable react/react-in-jsx-scope */
import groupBy from 'lodash/groupBy';

export const AI_DATA = {
  applicable_directives_regulations_title: 'Applicable Directives & Regulations',
  applicable_directives_regulations_description:
    'The described product must comply with the following：',
  directives_regulation_laws_rule: [
    {
      name: 'Consumer Product Safety Improvement Act (CPSIA)',
      number: 'Pub.L. 110-314',
      description:
        "Regulates safety standards for children's products to prevent lead and phthalate exposure.",
    },
    {
      name: 'Toy Safety Standard (ASTM F963)',
      number: '',
      description: 'Establishes safety requirements for toys to minimize hazards.',
    },
    {
      name: 'Federal Hazardous Substances Act (FHSA)',
      number: '',
      description: "Regulates hazardous substances in toys and children's articles.",
    },
  ],
  standards: [
    {
      code: 'ASTM F963-17',
      name: 'Standard Consumer Safety Specification for Toy Safety',
    },
    {
      code: 'CFR 16 Part 1301',
      name: 'Regulations for Determining Lead Content in Paint and Similar Surface Coatings',
    },
    {
      code: 'CFR 16 Part 1500',
      name: 'Regulations under the Federal Hazardous Substances Act',
    },
  ],
  safety_risk_analysis_Title: 'Safety Risk Analysis',
  safety_risk_analysis_description: 'Hazards associated with the described product:',
  safety_risk_category_name: [
    {
      category: 'Physical/Mechanical',
      description: 'Small parts may pose choking hazards to young children.',
    },
    {
      category: 'Chemical',
      description: 'Uncertified dyes may contain harmful pigments; potential lead exposure.',
    },
    {
      category: 'Hygiene',
      description: 'Non-antibacterial surface may promote microbial growth.',
    },
    {
      category: 'Food Imitation',
      description: 'Decorative items resembling food could lead to accidental ingestion.',
    },
  ],
  request_documentation_title: 'Required Documentation',
  request_documentation_category_name: [
    {
      category: 'Product Compliance & Manufacturing',
      document_name: 'Technical File',
      document_description: 'Must include risk assessment, test reports, and labelling details.',
    },
    {
      category: 'Product Compliance & Manufacturing',
      document_name: 'Certificate of Compliance',
      document_description: 'Document certifying compliance with applicable safety standards.',
    },
    {
      category: 'Product Compliance & Manufacturing',
      document_name: 'Material Safety Data Sheets (MSDS)',
      document_description: 'Safety documents for any chemicals or materials used.',
    },
    {
      category: 'Logistics & Shipping',
      document_name: 'Bill of Lading',
      document_description: 'Document issued by a carrier to acknowledge receipt of cargo.',
    },
    {
      category: 'Logistics & Shipping',
      document_name: 'Shipping Invoice',
      document_description: 'Invoice that details the items being shipped and their value.',
    },
    {
      category: 'Customs',
      document_name: 'Customs Declaration Form',
      document_description: 'Form required for customs processing of imported goods.',
    },
    {
      category: 'Customs',
      document_name: 'Import License',
      document_description: 'Document required to legally import certain goods.',
    },
    {
      category: 'Customs',
      document_name: 'Product Specifications',
      document_description: 'Detailed description of the product for customs review.',
    },
  ],
  recall_title: 'Recall History of Similar Product',
  recalls_description: [
    {
      noted_hazard: 'Lead content exceeding safe levels found in plastic figures.',
      reason: 'Non-compliance with CPSIA standards.',
    },
    {
      noted_hazard: 'Choking hazard due to small detachable parts.',
      reason: 'Failure to meet ASTM F963 toy safety regulations.',
    },
    {
      noted_hazard: 'Chemical exposure risks from hazardous dyes in decorations.',
      reason: 'Dyes not approved under federal chemical safety guidelines.',
    },
    {
      noted_hazard: 'Potential for surface mold due to material choice.',
      reason: 'Inadequate antimicrobial treatment.',
    },
    {
      noted_hazard: 'Imitation food items leading to ingestion issues.',
      reason: 'Misleading design of toy might cause confusion.',
    },
  ],
  message: 'AI insight successfully generated.',
};
const directiveItems = AI_DATA.directives_regulation_laws_rule.map((item, index) => {
  return {
    title: index === 0 ? 'Directive' : '',
    fieldName: item.name,
    fieldTitle: `${item.name} - ${item.number} - ${item.description}`,
  };
});
const testItemItems = AI_DATA.standards.map((item, index) => {
  return {
    title: index === 0 ? 'Test Item' : '',
    fieldName: item.name,
    fieldTitle: `${item.code} - ${item.name}`,
  };
});

export const AI_DATA_ARR = [
  {
    text: AI_DATA.applicable_directives_regulations_title,
    description: AI_DATA.applicable_directives_regulations_description,
    items: [...directiveItems, ...testItemItems],
  },
  {
    text: AI_DATA.safety_risk_analysis_Title,
    description: AI_DATA.safety_risk_analysis_description,
    items: AI_DATA.safety_risk_category_name.map((item) => {
      return {
        fieldTitle: item.category,
        fieldDescription: item.description,
      };
    }),
  },
  {
    text: AI_DATA.recall_title,
    items: AI_DATA.recalls_description.map((item) => {
      return {
        fieldTitle: (
          <>
            {item.recall_date} | {item.noted_hazard} | {item.reason} | {item.case_number} |{' '}
            <a href={item.citiation_link} target="_Blank" rel="noreferrer">
              {item.citiation_link}
            </a>
          </>
        ),
      };
    }),
  },
  {
    text: AI_DATA.request_documentation_title,
    items: AI_DATA.request_documentation_category_name.map((item) => {
      return {
        title: item.category,
        fieldName: item.category,
        fieldTitle: `${item.document_name} - ${item.document_description}`,
      };
    }),
  },
];
export const getAIData = (tData) => {
  if (!tData) return [];
  const tDirectiveItems = (tData.directives_regulation_laws_rule || []).map((item, index) => {
    return {
      title: index === 0 ? 'Directive' : '',
      fieldName: `Directive___${item.name} - ${item.number} - ${item.description}`,
      fieldTitle: `${item.name} - ${item.number} - ${item.description}`,
    };
  });
  const tTestItemItems = (tData.standards || []).map((item, index) => {
    return {
      title: index === 0 ? 'Test Item' : '',
      fieldName: `Test Item___${item.name} - ${item.code}`,
      fieldTitle: `${item.name} - ${item.code}`,
    };
  });
  const safetyRiskItems = groupBy(tData.safety_risk_category_name || [], 'category');
  const otherGroupedItems = groupBy(tData.request_documentation_category_name || [], 'category');
  const otherItems = [];
  Object.keys(otherGroupedItems).forEach((key) => {
    otherGroupedItems[key].forEach((item, index) => {
      otherItems.push({
        title: index === 0 ? key : '',
        fieldName: `Documents___${item.category} - ${item.document_name} - ${item.document_description}`,
        fieldTitle: `${item.document_name} - ${item.document_description}`,
      });
    });
  });

  return [
    {
      text: tData.applicable_directives_regulations_title,
      description: tData.applicable_directives_regulations_description,
      items: [...tDirectiveItems, ...tTestItemItems],
    },
    {
      text: tData.safety_risk_analysis_Title,
      description: tData.safety_risk_analysis_description,
      items: Object.keys(safetyRiskItems).map((tKey) => {
        return {
          fieldTitle: tKey,
          fieldDescriptions: safetyRiskItems[tKey].map((obj) => obj.description),
          fieldGroup: true,
        };
      }),
    },
    {
      text: tData.recall_title,
      items: (tData.recalls_description || []).map((item) => {
        return {
          fieldTitle: (
            <>
              {[item.recall_date, item.noted_hazard, item.reason, item.case_number]
                .filter((v) => !!v)
                .join(' | ')}
              {!!item.citiation_link ? (
                <>
                  {' | '}
                  <a href={item.citiation_link} target="_Blank" rel="noreferrer">
                    {item.citiation_link}
                  </a>
                </>
              ) : (
                ''
              )}
            </>
          ),
        };
      }),
    },
    {
      text: tData.request_documentation_title,
      items: otherItems,
    },
  ];
};
